<template>
	<div class="callback white">
    <div id="speed">
      <v-row>
        <v-col
          cols="6"
          class="ma-0 pa-0 hidden-sm-and-down"
        >
          <v-img src="@/assets/images/others/speedup_process.jpg" width="100%" height="700px" position="left"></v-img>
        </v-col>
        <v-col
          cols="12" sm="12" md="6" lg="6" xl="6"
          :class="[ $vuetify.breakpoint.mdAndUp ? 'box-md-and-up' : 'box-sm-and-down']"
          data-aos="fade-left"
        >
          <v-form ref="speedForm">
            <v-container fill-height>
              <div>
                <div class="display-3 font-weight-black mb-5 primary--text">Hi!</div>
                <h3 class="primary--text mb-5">Thanks for your request and we'll call you right away! You can speed up the process by providing the following:</h3>
                  <v-row>
                    <v-col cols="12" sm="12" md="8" lg="8" xl="8">
                      <!-- Name -->
                      <v-text-field
                        label="Name*"
                        type="text"
                        ref="name"
                        v-model="name"
                        :rules="[() => !!name || 'This field is required']"
                        :error-messages="errorMessages"
                      ></v-text-field>

                      <!-- Email address -->
                      <v-text-field
                        label="Email address*"
                        type="text"
                        ref="email"
                        v-model="email"
                        :rules="[() => !!email || 'This field is required',
                                  () => /.+@.+\..+/.test(email) || 'Email must be valid']"
                        :error-messages="errorMessages"
                      ></v-text-field>

                      <!-- Provider -->
                      <v-select
                        ref="provider"
                        v-model="provider"
                        :items="providers"
                        label="Provider*"
                        :rules="[() => !!provider || 'This field is required']"
                        :error-messages="errorMessages"
                      ></v-select>
                    </v-col>
                  </v-row>
              </div>
              <div>
                <base-button
                  name="Hurry Up Doc!"
                  icon="mdi-arrow-right"
                  color="#0e6ccd"
                  x-large
                  @click="confirmSpeedInfo()"
                ></base-button>
              </div>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
    </div>

    <base-confirm-dialog
			v-model="confirmDialog"
			title="Continue"
			message="Would you like to request an immediate consultation from a doctor?"
			@do="saveSpeedInfo()"
		></base-confirm-dialog>

		<base-success-dialog
			v-model="successDialog"
			title="Thank you!"
			message="You successfully submitted your request to speed up callback process."
		></base-success-dialog>
  </div>
</template>

<script>
export default {
  name: "CallbackSpeed",

  components: {
  },

  data() {
    return {
			/* form fields */
			name: null,
			email: null,
			provider: null,
			/* form fields */
			errorMessages: '',
			confirmDialog: false,
      successDialog: false,
      providers: [
        "Provider 1",
        "Provider 2",
        "Provider 3"
      ]
		}
  },

  computed: {
    speedForm() {
      return {
        name: this.name,
        email: this.email,
        provider: this.provider,
      }
    },
  },

  mounted() {
    //
  },

  methods: {
    confirmSpeedInfo() {
      if (this.$refs.speedForm.validate()) this.confirmDialog = true;
		},
		saveSpeedInfo() {
			this.confirmDialog = false;

      // try {
      //   let save = await Api.create(this.contactForm);

      //   if (save) {
          this.successDialog = true;
      //     localStorage.removeItem('cartItems');
      //   }
      //   else {
      //     console.log("Sorry, there was a problem saving your transaction.");
      //   }
      // }
      // catch(error) {
      //   console.log(error);
      // }
		}
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";


.callback {
  height: 700px;
  margin-top: 200px;
  margin-bottom: 200px;

  #speed {
    .box-md-and-up {
      padding: 5% 8% 5% 5%;
    }
    .box-sm-and-down {
      padding: 5%;
    }
  }
}
</style>